module.exports = __webpack_public_path__ + "static/media/helene_gedicht.93767cb.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/helene_gedicht.mp3
// module id = l2wc
// module chunks = 1